import { useDispatch } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { useTranslation } from 'react-i18next';

import { ShowDialogParams } from '@/store/dialog/types';
import { ShowDialog } from '@/store/dialog/actions';
import useMobile from '../useMobile';

export const useExitModal = (
    isSavedRef: React.MutableRefObject<boolean>,
    breadcrumbPath: string,
    translations: {
        title: string;
        cancelLabel?: string;
        confirmLabel?: string;
    },
    body: string | JSX.Element | JSX.Element[]
) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const profileMenuSelector = isMobile ? '.profileMenuAvatar' : '.bottomItemWrapper';

    const removeEventListeners = () => {
        document.querySelectorAll('.buttonList')[0]?.removeEventListener('click', handleExit);
        document.querySelectorAll(profileMenuSelector)[0]?.removeEventListener('click', addProfileMenuEventListener);
        document.querySelectorAll('.MuiMenu-list')[0]?.removeEventListener('click', handleExit);
    };

    const addProfileMenuEventListener = () => {
        document.querySelectorAll('.MuiMenu-list')[0]?.addEventListener('click', handleExit);
    };

    const handleExit = (event?: Event, isBreadcrumbClicked?: boolean) => {
        if (!isSavedRef.current) {
            event?.preventDefault();
            event?.stopPropagation();
            const params: ShowDialogParams = {
                title: translations.title,
                cancelLabel: translations?.cancelLabel || t('cancel'),
                confirmLabel: translations?.confirmLabel || t('confirm'),
                body,
                onClickConfirm: () =>
                    isBreadcrumbClicked ? dispatch(Push(breadcrumbPath)) : continueMenuButtonClick(event.target),
            };
            dispatch(ShowDialog(params));
            return;
        }
        isBreadcrumbClicked ? dispatch(Push(breadcrumbPath)) : continueMenuButtonClick(event.target);
    };

    const continueMenuButtonClick = (target: EventTarget) => {
        removeEventListeners();
        const clickEvent = new Event('click', { bubbles: true });
        target.dispatchEvent(clickEvent);
    };

    const boot = () => {
        document.querySelectorAll('.buttonList')[0]?.addEventListener('click', handleExit);
        document.querySelectorAll(profileMenuSelector)[0]?.addEventListener('click', addProfileMenuEventListener);
    };

    const cleanup = () => {
        removeEventListeners();
    };

    return { boot, cleanup, handleExit };
};
